import type { ComponentType } from 'react'

import { InfoPopover } from '@/ui'

// Wraps a field component so a question carrying `info` shows an InfoPopover
// beside the control. When there is no `info` the field renders unchanged, so
// there is no layout shift for questions without a disclaimer.
export const withInfo = <P extends object>(
  Field: ComponentType<P>
): ComponentType<P> => {
  const WithInfo = (props: P) => {
    const { info } = props as { info?: string }
    if (!info) return <Field {...props} />

    return (
      <div className="flex items-start gap-1">
        <div className="flex-1">
          <Field {...props} />
        </div>
        <div className="h-14 flex items-center">
          <InfoPopover info={info} />
        </div>
      </div>
    )
  }

  WithInfo.displayName = `withInfo(${Field.displayName ?? Field.name})`

  return WithInfo
}
